import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const Signup = (props) => {

    let navigate = useNavigate();

    let [credentials, setcredentials] = useState({
        email: "", password: "", name: "", cpassword: ""
    })

    let [same, setsame] = useState("")
    let [alpha, setalpha] = useState("")
    let [numeric, setnumeric] = useState("")
    let [special, setspecial] = useState("")
    let [donotmatch, setdonotmatch] = useState("-none")


    const handleclick = async (e) => {
        e.preventDefault();


        let data = { email: credentials.email, name: credentials.name, password: credentials.password };

        const response = await fetch("https://floatnotes.onrender.com/api/auth", {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        let json = await response.json()
        if (json.error == 'user already exist') {
            props.showalert("User Already Exist", "danger");
            navigate("/login")
        } else {
            props.showalert("Signed Up Successfully", "success");
            navigate("/login")
        }

    }

    const onchange = (e) => {


        let cpass = document.getElementById("cpassword").value
        let pass = document.getElementById("password").value

        pass !== cpass?setdonotmatch(""):setdonotmatch("-none");
        !/[A-Z]/.test(pass) && !/[a-z]/.test(pass)?setalpha(""):setalpha("-none");
        !/[!@#$%^&*]/.test(pass)?setspecial(""):setspecial("-none");
        !/[0-9]/.test(pass)?setnumeric(""): setnumeric("-none");
        

        if ((/[a-z]/.test(pass)) && ((/[0-9]/.test(pass))) && (/[!@#$%^&*]/.test(pass)) && (pass == cpass)) {
            setsame("-false")
        } else {
            setsame("")
        }

        setcredentials({ ...credentials, [e.target.name]: e.target.value })
    }

    return (
        <>
            <div className="container" onSubmit={handleclick}>
                <form>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name</label>
                        <input type="text" required minLength={5} value={credentials.name} className="form-control" id="name" name="name" onChange={onchange} />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                        <input type="email" required className="form-control" value={credentials.email} id="email" name="email" onChange={onchange} aria-describedby="emailHelp" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input type="password" required minLength={8} className="form-control" value={credentials.password} id="password" name="password" onChange={onchange} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="cpassword" className="form-label">Confirm Password</label>
                        <input type="password" required minLength={8} className="form-control" value={credentials.cpassword} id="cpassword" name="cpassword" onChange={onchange} />
                    </div>
                    <p className={`d${donotmatch}`} style={{ color: "red" }}><i className="fa-solid fa-circle-xmark"></i> Password do not match</p>
                    <p className={`d${donotmatch=="-none"?"":"-none"}`} style={{ color: "green" }}><i className="fa-solid fa-check"></i> Password matches</p>


                    <p className={`d${alpha}`} style={{ color: "red" }}><i className="fa-solid fa-circle-xmark"></i> No Alphabets</p>
                    <p className={`d${alpha=="-none"?"":"-none"}`} style={{ color: "green" }}><i className="fa-solid fa-check"></i> Alphabets are there </p>


                    <p className={`d${numeric}`} style={{ color: "red" }}><i className="fa-solid fa-circle-xmark"></i> No Numbers</p>
                    <p className={`d${numeric=="-none"?"":"-none"}`} style={{ color: "green" }}><i className="fa-solid fa-check"></i> Numbers are there</p>


                    <p className={`d${special}`} style={{ color: "red" }}><i className="fa-solid fa-circle-xmark"></i> No Specials Characters</p>
                    <p className={`d${special=="-none"?"":"-none"}`} style={{ color: "green" }}><i className="fa-solid fa-check"></i> Specials Characters are there</p>


                    <button className={`btn btn-dark disabled${same}`} >Signup</button>
                </form>
            </div>
        </>
    )
}

export default Signup